import React, { useState } from 'react';
import { citiesData } from './citiesData';
import MailerCard from './MailerCard';
import ReserveModal from './ReserveModal';
import SafeIcon from '../../common/SafeIcon';
import RetroBadge from '../../components/ui/RetroBadge';

const Reserve = () => {
  const [activeCityId, setActiveCityId] = useState(citiesData[0].id);
  const [activeSide, setActiveSide] = useState('front');
  const [reservedSlots, setReservedSlots] = useState({});
  const [selectedSlot, setSelectedSlot] = useState(null);

  const activeCity = citiesData.find(c => c.id === activeCityId);

  const handleSlotClick = (slotDetails) => {
    setSelectedSlot(slotDetails);
  };

  const handlePledgeSubmit = (slot) => {
    setReservedSlots(prev => ({ ...prev, [slot.id]: true }));
    setSelectedSlot(null);
  };

  return (
    <div className="bg-[#F8F4E6] min-h-screen py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        
        <div className="text-center mb-12">
          <RetroBadge text="West Valley Arizona Editions" color="bg-retro-teal text-white" rotation="-rotate-1" className="mb-6" />
          <h1 className="font-display text-5xl md:text-7xl uppercase tracking-tighter mb-4">
            Claim Your <span className="text-retro-blue">Local</span> Territory
          </h1>
          <p className="font-body text-xl font-bold max-w-2xl mx-auto text-gray-600">
            Monthly neighborhood mailers sent to Buckeye, Goodyear, Surprise, and more. 
            Choose your ad size and lock in your spot.
          </p>
        </div>

        {/* Controls */}
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6 mb-12 bg-white border-4 border-retro-brown rounded-2xl p-4 shadow-retro-sm">
          
          <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2">
            <span className="font-display uppercase text-sm mr-2 opacity-60">Select City:</span>
            {citiesData.map(city => (
              <button
                key={city.id}
                onClick={() => setActiveCityId(city.id)}
                className={`px-4 py-2 rounded-full font-body font-bold text-xs md:text-sm border-2 transition-all ${
                  activeCityId === city.id 
                    ? 'bg-retro-brown text-white border-retro-brown shadow-retro-sm' 
                    : 'bg-gray-100 text-gray-600 border-transparent hover:border-retro-brown'
                }`}
              >
                {city.name}
              </button>
            ))}
          </div>

          <div className="flex items-center gap-3 bg-gray-100 p-1.5 rounded-full border-2 border-retro-brown/20 shrink-0">
            <button
              onClick={() => setActiveSide('front')}
              className={`flex items-center gap-2 px-6 py-2 rounded-full font-display uppercase tracking-widest text-xs md:text-sm transition-all ${
                activeSide === 'front' ? 'bg-white border-2 border-retro-brown shadow-sm text-retro-brown' : 'text-gray-500 hover:text-retro-brown'
              }`}
            >
               Front Side
            </button>
            <button
              onClick={() => setActiveSide('back')}
              className={`flex items-center gap-2 px-6 py-2 rounded-full font-display uppercase tracking-widest text-xs md:text-sm transition-all ${
                activeSide === 'back' ? 'bg-white border-2 border-retro-brown shadow-sm text-retro-brown' : 'text-gray-500 hover:text-retro-brown'
              }`}
            >
               See Backside <SafeIcon name="RefreshCw" className="text-xs" />
            </button>
          </div>

        </div>

        {/* Interactive Card Area */}
        <MailerCard 
          city={activeCity} 
          side={activeSide} 
          reservedSlots={reservedSlots} 
          onSlotClick={handleSlotClick} 
        />

        <div className="mt-12 max-w-2xl mx-auto text-center bg-retro-brown text-retro-cream p-6 border-4 border-retro-yellow rounded-2xl">
          <p className="font-body font-bold italic">
            "We only allow high-quality local businesses. Each monthly mailer is a curated resource for West Valley homeowners."
          </p>
        </div>

      </div>

      {/* Reservation Modal */}
      {selectedSlot && (
        <ReserveModal 
          slot={selectedSlot} 
          onClose={() => setSelectedSlot(null)} 
          onSubmit={handlePledgeSubmit} 
        />
      )}

    </div>
  );
};

export default Reserve;